import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import digital7 from '../../assets/image/digital/digital7.png'
import digital8 from '../../assets/image/digital/digital8.png'

import elearningimplement from '../../assets/image/digital-learning/e-learning_implement.jpg'
export default class content extends Component {
    render() {
        const image=[
            {image:elearningimplement}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Digital Learning','E-Learning Content Development']} image={image} title="E-learning Platform Implementation" subtitle=""/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                We also help you in creating and converting your conventional content delivery into interactive digital learning delivery to ensure your millennials keep engaging with organization learning plan to fulfill their competencies.
                                <br/><br/>
                                <img src={digital7}/>
                                <br/>
                                <img src={digital8}/>
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
